

/// <reference path="DocumentTemplate.ts" />

// Generated class ArchivedDocumentTemplate_ManagedObject

class ArchivedDocumentTemplate_ManagedObject extends DocumentTemplate
{
}
